<script setup lang="ts">
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
</script>

<template>
  <div class="summary-skeleton" role="status">
    <span class="sr-only">{{ t('my_wallet.loading') }}</span>
    <div class="skeleton-line -title skeleton-shimmer" />
    <div class="skeleton-line -label skeleton-shimmer" />
    <div class="skeleton-line -large skeleton-shimmer" />
    <div class="skeleton-divider" />
    <div class="skeleton-line -label skeleton-shimmer" />
    <div class="skeleton-line -large skeleton-shimmer" />
    <div class="skeleton-bar skeleton-shimmer" />
    <div class="skeleton-note skeleton-shimmer" />
  </div>
</template>

<style scoped lang="scss">
@use '../../styles/skeleton';

.summary-skeleton {
  @apply relative flex flex-col gap-4 w-full p-6 rounded-lg border border-neutral-high-medium;

  .skeleton-line {
    @apply w-full rounded-sm;

    &.-title {
      @apply h-6 w-48;
    }

    &.-label {
      @apply h-3 w-32;
    }

    &.-large {
      @apply h-10;
    }
  }

  .skeleton-divider {
    @apply h-px w-full bg-neutral-high-medium;
  }

  .skeleton-bar {
    @apply h-[10px] w-full rounded-md;
  }

  .skeleton-note {
    @apply h-14 w-full rounded-md;
  }
}
</style>
